import { copy } from '@/report/copy'

export function NotFoundPage() {
  return (
    <main className="flex min-h-screen items-center justify-center p-4">
      <p className="text-sm text-gray-600">{copy.access.notFound}</p>
    </main>
  )
}
